<template>
  <div class="admin-withdraw-detail">
    <page-title title="用户信息">
      <ul class="info-form flex-form">
        <li class="form-item">
          <span class="form-item-label">店铺类型：</span>
          <div class="form-item-content">
            {{ storeAsset.store.type === 'PERSONAL' ? '个人店铺' : '机构店铺' }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">店铺名称：</span>
          <div class="form-item-content">
            <i class="el-icon-circle el-icon-s-shop" style="background-color:#005bff;padding:3px;border-radius:50%;"></i>
            <span>{{ storeAsset.store.name }}</span>
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">手机号：</span>
          <div class="form-item-content">
            {{ storeAsset.store.contact.phone }}
          </div>
        </li>
      </ul>
    </page-title>
    <page-title title="提现信息">
      <ul class="info-form">
        <li class="form-item double-item">
          <span class="form-item-label">审核状态：</span>
          <div class="form-item-content">
            <withdraw-state-label :status="withdraw.status || ''"></withdraw-state-label>
            <span v-if="withdraw.status !== 'REVIEWING'" class="text-action" @click="dialogTitle='审核记录';visible=true;">审核记录</span>
          </div>
          <template v-if="['REVIEW_FAILED', 'TRANSFER_FAILED'].includes(withdraw.status)">
            <span class="form-item-label">{{ withdraw.status === 'REVIEW_FAILED' ? '审核' : '提现' }}失败原因：</span>
            <div class="form-item-content">
              {{ withdraw.auditRemark }}
            </div>
          </template>
        </li>
        <li class="form-item double-item">
          <span class="form-item-label">提现金额：</span>
          <div class="form-item-content">￥{{ withdraw.amount }}</div>
          <span class="form-item-label">提现账号姓名：</span>
          <div class="form-item-content">
            {{ bankCard.realName || '- -' }}
          </div>
        </li>
        <li class="form-item double-item">
          <span class="form-item-label">提现银行：</span>
          <div class="form-item-content">
            {{ bankCard.bankCode ? bankname[bankCard.bankCode] : '- -' }}
          </div>
          <span class="form-item-label">提现卡号：</span>
          <div class="form-item-content">
            {{ bankCard.number }}
          </div>
        </li>
        <li class="form-item double-item">
          <span class="form-item-label">申请提现时间：</span>
          <div class="form-item-content">
            {{ withdraw.createdDate }}
          </div>
          <template v-if="['REVIEW_FAILED', 'REVIEWED'].includes(withdraw.status)">
            <span class="form-item-label">审核时间：</span>
            <div class="form-item-content">
              {{ withdraw.auditTime || '- -' }}
            </div>
          </template>
          <template v-else-if="['TRANSFER_FAILED', 'TRANSFERRED'].includes(withdraw.status)">
            <span class="form-item-label">转账时间：</span>
            <div class="form-item-content">
              {{ withdraw.transferTime || '- -' }}
            </div>
          </template>
        </li>
        <template v-if="withdraw.status === 'TRANSFERRED'">
          <li class="form-item">
            <span class="form-item-label">交易流水号：</span>
            <div class="form-item-content">
              {{ withdraw.serialNumber || '- -' }}
            </div>
          </li>
          <li class="form-item">
            <span class="form-item-label">交易凭证：</span>
            <div class="form-item-content">
              <el-image v-for="c in certificates" :src="c" :key="c" alt="凭证" :previewSrcList="certificates" />
            </div>
          </li>
          <li class="form-item">
            <span class="form-item-label">账号余额：</span>
            <div class="form-item-content">￥{{ storeAsset.balance }}</div>
          </li>
        </template>
      </ul>
    </page-title>
    <div class="btn-grp" v-if="withdraw.status === 'REVIEWING'">
      <el-button @click="pass">审核通过</el-button>
      <el-button @click="dialogTitle = '审核不通过';visible = true;">
        审核不通过
      </el-button>
    </div>
    <div class="btn-grp" v-if="withdraw.status === 'REVIEWED'">
      <el-button @click="dialogTitle = '提现成功';visible = true;">
        提现成功
      </el-button>
      <el-button @click="dialogTitle = '提现失败';visible = true;">
        提现失败
      </el-button>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="visible" width="600px" :close-on-click-modal="false">
      <div class="vertify-complete" v-if="dialogTitle === '提现成功'">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="交易流水号：">
            <el-input v-model="form.serial" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="交易凭证：">
            <el-upload
              class="certificate-upload"
              :action="upAddress"
              :headers="headers"
              :on-success="success"
              :on-error="error"
              :on-progress="progress"
              :show-file-list="false"
            >
              <i class="el-icon-plus"></i>
              <img v-if="file" v-pic="file.location" />
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="vertify-fail" v-if="dialogTitle === '审核不通过'">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="审核不通过原因：">
            <el-input v-model="form.remark" placeholder="请输入" type="textarea" rows="7" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="vertify-fail" v-if="dialogTitle === '提现失败'">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="提现失败原因：">
            <el-input v-model="form.reason" placeholder="请输入" type="textarea" rows="7" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="dialogTitle === '审核记录'" class="vertify-log-list">
        <template v-for="(i, k) in auditLogList">
          <template v-if="k === 0">
            <time-line :key="i.id" :timestamp="i.createdDate" context="用户提交审核"></time-line>
            <time-line :finished="auditLogList.length===1" :key="i.id" :timestamp="i.timestamp" :context="`${i.pass?'审核通过。':'审核未通过，原因：'+withdraw.auditRemark+'。'}`" :addon="formatterAuditor(i.userInfo)"/>
          </template>
          <time-line v-else finished :key="i.id" :timestamp="i.timestamp" :context="`${i.pass?'提现成功。':'提现失败，原因：'+withdraw.auditRemark+'。'}`" :addon="formatterAuditor(i.userInfo)"/>
        </template>
      </div>
      <div class="btn-grp" slot="footer">
        <el-button @click="confirm">确定</el-button>
        <el-button @click="visible=false;file='';">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTitle from '@/components/pageTitle.vue';
import { failWithdrawById, getWithdrawById, passWithdrawById, withdrawFailById, withdrawSuccById } from '@/api/req';
import WithdrawStateLabel from './components/withdrawStateLabel.vue';
import bankname from '@/utils/bankname';
import { echoAddress, upAddress } from '@/config/config';
import TimeLine from '@/components/timeLine';

export default {
  components: { pageTitle, WithdrawStateLabel, TimeLine },
  name: 'withdrawDetail',
  data() {
    return {
      loading: true,
      visible: false,
      dialogTitle: '',
      form: {},
      withdraw: {},
      filelist: [],
      file: '',
      loadingMsg: ''
    };
  },
  computed: {
    pageId() {
      return this.$route.params.id;
    },
    storeAsset() {
      return this.withdraw.storeAsset || { store: { contact: {} } };
    },
    bankCard() {
      return this.withdraw.bankCard || {};
    },
    certificates() {
      return this.withdraw?.certificates?.map(c => echoAddress + c.location) || [];
    },
    bankname: () => bankname,
    upAddress: () => upAddress,
    headers() {
      return { Authorization: 'Bearer ' + sessionStorage.getItem('token') };
    },
    auditLogList() {
      return this.withdraw?.audits || []
    }
  },
  watch: {
    visible(visible) {
      if (!visible) {
        this.form = {};
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$ajax
        .get(getWithdrawById(this.pageId))
        .then(res => {
          this.loading = false;
          this.withdraw = Object.freeze(res.data);
        })
        .catch(err => {
          this.loading = false;
          console.log(err.data);
        });
    },
    pass() {
      this.$confirm('审核通过, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$ajax.put(passWithdrawById(this.pageId)).then(res => {
            this.getData();
            this.$message({
              message: '审核成功',
              type: 'success'
            });
          });
        })
        .catch(() => {});
    },
    confirm() {
      switch (this.dialogTitle) {
        case '提现成功':
          this.withdrawS();
          break;
        case '提现失败':
          this.withdrawF();
          break;
        case '审核不通过':
          this.fail();
          break;
        default:
          this.visible = false;
          break;
      }
    },
    fail() {
      if (this.form.remark) {
        this.$ajax
          .put(failWithdrawById(this.pageId), {
            id: this.pageId,
            remark: this.form.remark
          })
          .then(res => {
            this.visible = false;
            this.getData();
            this.$message.success('审核成功');
          })
          .catch(err => {
            console.log(err.data);
            this.$message.info('审核失败');
          });
      } else {
        this.$message({
          message: '请填写信息',
          type: 'warning'
        });
      }
    },
    withdrawS() {
      if (this.form.serial && this.file) {
        delete this.file.id;
        let certificates = [
          {
            type: 'IMAGE',
            file: this.file
          }
        ];
        this.$ajax
          .put(withdrawSuccById(this.pageId), {
            id: this.pageId,
            serialNumber: this.form.serial,
            certificates
          })
          .then(res => {
            this.visible = false;
            this.getData();
          })
          .catch(err => {
            this.$message.info('操作失败');
            console.log(err);
          });
      } else {
        this.$message.warning('请输入流水号并上传凭证！');
      }
    },
    withdrawF() {
      if (this.form.reason) {
        this.$ajax
          .put(withdrawFailById(this.pageId), {
            id: this.pageId,
            remark: this.form.reason
          })
          .then(res => {
            this.visible = false;
            this.$message.success('操作成功');
            this.getData();
          })
          .catch(err => {
            this.$message.info('操作失败');
          });
      } else {
        this.$message({
          message: '请填写信息',
          type: 'warning'
        });
      }
    },
    success(res, file, filelist) {
      this.loadingMsg.close();
      this.$message.success('文件上传成功！');
      this.file = res;
      console.log(res);
    },
    error(err) {
      this.loadingMsg.close();
      this.$message.info('上传失败！');
    },
    progress() {
      // this.loadingMsg = this.$message.info('文件上传中，请稍后...');
      this.loadingMsg = this.$loading({
        lock: true,
        text: '文件上传中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)',
        fullscreen: true
      });
    },
    formatterAuditor(userinfo) {
      if (!userinfo) return '';
      let auditorName = '';
      if (userinfo.state === 'CERTIFIED') {
        switch (userinfo.type) {
          case 'ENTERPRISE':
            auditorName = userinfo.legalPerson;
            break;
          case 'PERSONAL':
            auditorName = userinfo.realName;
            break;
          default:
            auditorName = userinfo.nickname;
            break;
        }
      }
      return `审核员：${auditorName || userinfo.nickname}`;
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.admin-withdraw-detail {
  ul,
  li {
    list-style: none;
  }
  .vertify-log-list {
    padding-left: 80px;
  }
  .flex-form {
    display: flex;
    align-items: center;
    & .form-item {
      margin-top: 0;
      min-width: 248px;
      margin-right: 8px;
    }
    .form-item-label {
      width: auto;
    }
  }
  .info-form {
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
  }
  .double-item {
    display: inline-block;
    // max-width: 388px;
    .form-item-content {
      width: 244px;
      max-width: 244px;
      align-self: flex-start;
      display: flex;
    }
    .text-action {
      font-weight: 400;
      color: #19b0ea;
      cursor: pointer;
      margin-left: 12px;
      &:hover {
        color: #59c5f0;
      }
    }
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      width: 84px;
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      margin-right: 6px;
      align-self: flex-start;
    }
    &-content {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      max-width: 760px;
      .el-image {
        height: 110px;
        width: 168px;
        border-radius: 4px;
        font-size: 0;
        vertical-align: bottom;
        .el-icon-circle-close {
          font-size: 40px;
        }
      }
      .el-image + .el-image {
          margin-left: 8px;
      }
      .el-icon-circle {
        margin-right: 8px;
        color: #fff;
        vertical-align: middle;
      }
    }
  }
  .btn-grp {
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
  .el-dialog {
    .el-form-item__label {
      font-size: 12px;
      color: #040b28;
    }
    .certificate-upload {
      .el-upload.el-upload--text {
        height: 168px;
        width: 256px;
        border-radius: 4px;
        border: 1px dashed #dcdcdc;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        i {
          position: absolute;
          font-size: 36px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
